import { useTranslation } from "react-i18next";
import "../../assets/styles/bootstrap.css";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";

function DepartedListElement(departed) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  departed = departed.departed;

  const handleClick = (uuid) => {
    navigate("/DepartedDetails", { state: { uuid: uuid } });
  };

  return (
    <>
          <div
            style={{cursor:"pointer"}}
            onClick={() => handleClick(departed.uuid)}
            className="ms-2 me-auto"
          >
            <div className="fw-bold">
              {departed.namePrefix && ` ${departed.namePrefix} `}
              {departed?.familyName && ` ${departed.familyName} `}
              {departed?.bornFamilyName && (
                <span style={{ fontWeight: "normal" }}>
                          {"(" + departed.bornFamilyName + ")"}{" "}
                        </span>
              )}
              {departed?.givenName && ` ${departed.givenName} `}
            </div>
            {departed?.bornYear != null &&
              departed?.bornYear !== 0 &&
              `${departed?.bornYear} - `}
            {departed?.deathYear != null &&
              departed?.deathYear !== 0 &&
              `${departed?.deathYear}`}
          </div>
          <Button
            variant="link"
            className="more-btn more-btn:hover"
            style={{ textDecoration: "none", color: "grey" }}
            onClick={() => handleClick(departed.uuid)}
          >
            {t("more")}
          </Button>
    </>)
}

export default DepartedListElement;